import { useState } from "react";
import { Card, Col, Row, Tab, Tabs } from "react-bootstrap";
import { FaFileLines } from "react-icons/fa6";
import { CgSoftwareDownload } from "react-icons/cg";
import { Title, ContainerMain, CardHeader, Box, CardIcon, CustomButton } from "./style";
import { getReportsData, getReportsDataSolicitacoesPDF, getReportsDataXlsx, getServicesDataAtendimentosPDF, getServicesDataCSV, getServicesDataXlsx } from "../../services/requests";
import Requests from "./requests";
import FlowTab from "./Flow";
import Services from "./services";
import { getReportsDataCsvFlow, getReportsDataPdfFlow, getReportsDataXlsxFlow } from "../../services/flow";
import { CircularProgress } from '@material-ui/core';
import { useStateValue } from "../../providers/StateProvider";
import { actionTypes } from "../../store/reducer";

interface LabelValue {
  label: string;
  value: string;
}

interface Filters {
  status: LabelValue | string;
  status_atual: LabelValue | string;
  model: LabelValue;
  createdData: string;
  dataFim: string;
  service: string;
  orgao: LabelValue;
  title: string;
  organSelected: number;
  organSlugSelected: string;
  cpf: string;
  protocol: string;
  flowSlug: string;
  servicoSlug: LabelValue;
  atendente?: LabelValue | string;
  setor: LabelValue | string;
  dataInicio: string;
  flow__slug: string;
  data: string;
  flowTitle?: string;
  filtro_ativo: {
    label: '',
    value: true
  },
}

const Reports = () => {
  const [, dispatch] = useStateValue();
  const [activeTab, setActiveTab] = useState<string>("Solicitações");
  const [filtersFlow, setFiltersFlow] = useState<Filters | null>(null);
  const [filtersServices, setFiltersServices] = useState<Filters | null>(null);
  const [filtersRequests, setFiltersRequests] = useState<Filters | null>(null);
  const [loadingType, setLoadingType] = useState<null | 'csv' | 'xlsx' | 'pdf'>(null);

  const buildParams = (filters: Filters) => {
    let statusParam;
    if (Array.isArray(filters.status)) {
      statusParam = filters.status.map(statusItem => typeof statusItem === 'string' ? statusItem : statusItem.value);
    } else if (typeof filters.status === 'object') {
      statusParam = [filters.status.value];
    } else {
      statusParam = filters.status;
    }
    let statusAtualParam;
    if (Array.isArray(filters.status_atual)) {
      statusAtualParam = filters.status_atual.map(statusAtualItem => typeof statusAtualItem === 'string' ? statusAtualItem : statusAtualItem.value);
    } else if (typeof filters.status_atual === 'object') {
      statusAtualParam = [filters.status_atual.value];
    } else {
      statusAtualParam = filters.status_atual;
    }

    let statusSetorParam;
    if (Array.isArray(filters.setor)) {
      statusSetorParam = filters.setor.map(statusAtualItem => typeof statusAtualItem === 'string' ? statusAtualItem : statusAtualItem.value);
    } else if (typeof filters.setor === 'object') {
      statusSetorParam = [filters.setor.value];
    } else {
      statusSetorParam = filters.setor;
    }

    let atendenteParam;
    if (Array.isArray(filters.atendente)) {
      atendenteParam = filters.atendente.map(atendenteItem => typeof atendenteItem === 'string' ? atendenteItem : atendenteItem.value);
    } else if (typeof filters.atendente === 'object') {
      atendenteParam = [filters.atendente.value];
    } else {
      atendenteParam = [filters.atendente];
    }
    const params = {
      status: statusParam,
      status_atual: statusAtualParam,
      flow__slug: filters.flow__slug,
      modelo: filters?.model?.value && Boolean(filters?.model?.value),
      servico_slug: filters?.servicoSlug?.value,
      orgao: filters?.orgao?.value,
      cpf: filters?.cpf?.replace(/\D/g, ''),
      data_inicio: filters?.dataInicio,
      data_fim: filters?.dataFim,
      search: filters?.title,
      protocolo: filters?.protocol,
      setor: statusSetorParam,
      filtro_ativo: filters?.filtro_ativo?.value,
      data: filters?.createdData !== "" ? filters?.createdData : filters?.data,
      atendente: atendenteParam,
    };

    Object.keys(params).forEach(key => params[key] === undefined && delete params[key]);
    return params;
  };

  const downloadData = async (params: ReturnType<typeof buildParams>, type: 'csv' | 'xlsx' | 'pdf') => {
    try {
      let response;
      setLoadingType(type);
      let paramsReports: any = { ...params };

      if (activeTab === 'Solicitações') {
        const { atendente, ...filteredParams } = params;
        paramsReports = filteredParams as any;
      }

      switch (activeTab) {
        case 'Solicitações':
          switch (type) {
            case 'xlsx':
              response = await getReportsDataXlsx(paramsReports);
              break;
            case 'csv':
              response = await getReportsData(paramsReports);
              break;
            case 'pdf':
              response = await getReportsDataSolicitacoesPDF(paramsReports);
              break;
          }
          break;
        case 'Fluxos':
          switch (type) {
            case 'xlsx':
              response = await getReportsDataXlsxFlow(params);
              break;
            case 'csv':
              response = await getReportsDataCsvFlow(params);
              break;
            case 'pdf':
              response = await getReportsDataPdfFlow(params);
              break;
          }
          break;
        case 'Atendimentos':
          switch (type) {
            case 'xlsx':
              response = await getServicesDataXlsx(params);
              break;
            case 'csv':
              response = await getServicesDataCSV(params);
              break;
            case 'pdf':
              response = await getServicesDataAtendimentosPDF(params);
              break;
          }
          break;
        default:
          throw new Error('Tab inválida.');
      }

      if (response?.status === 200) {
        dispatch({
          type: actionTypes.SET_FLASH_MESSAGE,
          flashMessage: {
            show: true,
            type: 'success',
            title: 'Sucesso',
            message: response?.data?.message,
          },
        });
      }
      // remover a lógica de criar arquivos, sem necessidade;
      // if (response) {
      //   let blob;
      //   let downloadUrl;
      //   const now = new Date();
      //   const day = now.getDate().toString().padStart(2, '0');
      //   const month = (now.getMonth() + 1).toString().padStart(2, '0');
      //   const year = now.getFullYear();
      //   const hour = now.getHours().toString().padStart(2, '0');
      //   const minute = now.getMinutes().toString().padStart(2, '0');
      //   const second = now.getSeconds().toString().padStart(2, '0');

      //   const formattedDateTime = activeTab === 'Fluxos'
      //     ? `${day}-${month}-${year}_${hour}-${minute}-${second}`
      //     : activeTab === 'Solicitações' ? `${filtersRequests.flowTitle}-${day}-${month}-${year}_${hour}-${minute}-${second}` : `${day}-${month}-${year}`;

      //   if (type === 'pdf') {
      //     downloadUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      //   } else {
      //     const mimeType = type === 'csv' ? 'text/csv;charset=utf-8;' : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      //     blob = new Blob([response.data], { type: mimeType });
      //     downloadUrl = window.URL.createObjectURL(blob);
      //   }

      //   const link = document.createElement('a');
      //   link.href = downloadUrl;
      //   link.setAttribute('download', `${activeTab}_${formattedDateTime}.${type}`);
      //   document.body.appendChild(link);
      //   link.click();
      //   link.remove();
      // }
      setLoadingType(null);
    } catch (error) {
      dispatch({
        type: actionTypes.SET_FLASH_MESSAGE,
        flashMessage: {
          show: true,
          type: 'error-alt',
          title: 'Erro ao gerar relatório',
          message: 'Erro ao buscar dados dos relatórios',
        },
      });
      console.error("Erro ao buscar dados dos relatórios:", error);
      setLoadingType(null);
    }
  };

  const fetchDataCSV = () => {
    const currentFilters = activeTab === 'Solicitações' ? filtersRequests : activeTab === 'Fluxos' ? filtersFlow : filtersServices;
    if (currentFilters) {
      const params = buildParams(currentFilters);
      downloadData(params, 'csv');
    }
  };

  const fetchDataXlsx = () => {
    const currentFilters = activeTab === 'Solicitações' ? filtersRequests : activeTab === 'Fluxos' ? filtersFlow : filtersServices;
    if (currentFilters) {
      const params = buildParams(currentFilters);
      downloadData(params, 'xlsx');
    }
  };

  const fetchDataPDF = () => {
    const currentFilters = activeTab === 'Solicitações' ? filtersRequests : activeTab === 'Fluxos' ? filtersFlow : filtersServices;
    if (currentFilters) {
      const params = buildParams(currentFilters);
      downloadData(params, 'pdf');
    }
  };

  return (
    <ContainerMain>
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Box>
                <CardIcon>
                  <FaFileLines size={20} />
                </CardIcon>
                <Title>Relatórios</Title>
              </Box>
              <Box style={{ gap: '8px', display: 'flex', flexWrap: 'wrap' }}>
                <CustomButton variant="filter" onClick={() => fetchDataPDF()} disabled={!filtersRequests?.servicoSlug.value && activeTab === 'Solicitações'}>
                  {loadingType === 'pdf' ? <CircularProgress size={18} color="inherit" /> : <CgSoftwareDownload size={20} />} Imprimir
                </CustomButton>

                <CustomButton variant="filter" onClick={() => fetchDataCSV()} disabled={!filtersRequests?.servicoSlug.value && activeTab === 'Solicitações'}>
                  {loadingType === 'csv' ? <CircularProgress size={18} color="inherit" /> : <CgSoftwareDownload size={20} />} Exportar para CSV
                </CustomButton>

                <CustomButton variant="filter" onClick={() => fetchDataXlsx()} disabled={!filtersRequests?.servicoSlug.value && activeTab === 'Solicitações'}>
                  {loadingType === 'xlsx' ? <CircularProgress size={18} color="inherit" /> : <CgSoftwareDownload size={20} />} Exportar para Excel
                </CustomButton>
              </Box>
            </CardHeader>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              id="reports-tab"
            >
              <Tab eventKey="Solicitações" title="Solicitações" className="mx-3">
                <Requests filtersRequests={filtersRequests} setFiltersRequests={setFiltersRequests} />
              </Tab>
              <Tab eventKey="Fluxos" title="Fluxos" className="mx-3">
                <FlowTab filtersFlow={filtersFlow} setFiltersFlow={setFiltersFlow} />
              </Tab>
              <Tab eventKey="Atendimentos" title="Atendimentos" className="mx-3">
                <Services filtersService={filtersServices} setFiltersService={setFiltersServices} />
              </Tab>
            </Tabs>
          </Card>
        </Col>
      </Row>
    </ContainerMain >
  );
};

export default Reports;
